import 'bootstrap/dist/css/bootstrap.min.css';
import './theme.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker'ı daha güvenli bir şekilde kaydet
try {
  serviceWorkerRegistration.register({
    onSuccess: (registration) => {
      console.log('Service worker başarıyla kaydedildi:', registration);
    },
    onUpdate: (registration) => {
      console.log('Service worker güncellendi:', registration);
    },
    onError: (error) => {
      console.error('Service worker kayıt hatası:', error);
    }
  });
} catch (error) {
  console.error('Service worker kayıt sırasında hata:', error);
}